/* Beekman Bakes: Monday-only dispatch, cutoff Monday 00:00 Eastern. */
(function () {
  'use strict';
  function nextShippingMonday(now) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(now || new Date());
    var date = {};
    parts.forEach(function (part) { date[part.type] = part.value; });
    var monday = new Date(Date.UTC(Number(date.year), Number(date.month) - 1, Number(date.day), 12));
    var days = (8 - monday.getUTCDay()) % 7 || 7;
    monday.setUTCDate(monday.getUTCDate() + days);
    return monday;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { nextShippingMonday: nextShippingMonday };
  }
  if (typeof document === 'undefined' || !window.customElements || customElements.get('bk-shipping-date')) return;

  class BeekmanShippingDate extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.render(); });
    }
    render() {
      var text = this.querySelector('[data-bk-shipping-text]');
      if (!text) return;
      var date = nextShippingMonday(new Date());
      var dateKey = date.toISOString().slice(0, 10);
      if (text.dataset.shipDate === dateKey && text.querySelector('strong')) return;
      var label = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric'
      }).format(date);
      var strong = document.createElement('strong');
      strong.textContent = label;
      text.replaceChildren('Ships ', strong, ' · we bake & ship fresh every Monday.');
      text.dataset.shipDate = dateKey;
    }
  }
  customElements.define('bk-shipping-date', BeekmanShippingDate);
  function refresh() {
    document.querySelectorAll('bk-shipping-date').forEach(function (element) { element.render(); });
  }
  // Horizon morphs cart children in place: connectedCallback alone is insufficient.
  var observer = new MutationObserver(function (records) {
    var touchedMessage = records.some(function (record) {
      if (record.target.nodeType === 1 && record.target.closest('bk-shipping-date')) return true;
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('bk-shipping-date') || node.querySelector('bk-shipping-date'));
      });
    });
    if (touchedMessage) refresh();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // Refresh open tabs across the cutoff, and immediately on return to the page.
  window.setInterval(refresh, 30000);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', refresh);
})();
